
<div *ngIf="!selectedEvent" class="diary-event-groups">
  <div *ngIf="diaryEvents" class="diary-event-groups">
    <div *ngFor="let diaryEvent of diaryEvents">
      <div *ngIf="!isUndated" class="diary-event-group">{{diaryEvent.GroupName}}</div>
      <mojo-diary-event *ngFor="let event of diaryEvent.DiaryEvents" [isUndated]="isUndated" [event]="event" (onDiaryEventClicked)="diaryEventClicked($event)"></mojo-diary-event>
    </div>
  </div>

  <div *ngIf="!diaryEvents || diaryEvents.length == 0" class="no-diary-events">
    <span>There are no events for the period selected.</span>
  </div>
</div>

<mojo-diary-event-details *ngIf="selectedEvent" [isUndated]="isUndated" class="diary-event-details" (onClicked)="clearSelectedDiaryEvent($event)" [diaryEvent]="selectedEvent"></mojo-diary-event-details>

